var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { getStopWithBoothClue } from '@/common/api/shop';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import ScheduleTag from '../Tag/ScheduleTag.vue';
var BoothCascader = /** @class */ (function (_super) {
    __extends(BoothCascader, _super);
    function BoothCascader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* data */
        _this.options = [];
        _this.checkOptions = [];
        return _this;
    }
    Object.defineProperty(BoothCascader.prototype, "curProps", {
        // 当前的选项属性
        get: function () {
            return Object.assign({
                // lazy: true, // 模糊搜索
                multiple: this.multiple,
            }, this.props);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BoothCascader.prototype, "curAttrs", {
        get: function () {
            // 设置属性默认值
            return Object.assign({
                'collapse-tags': true,
                // filterable: Array.isArray(this.options) && this.options.length >= 5,
                filterable: true,
                'filter-method': this.inputEnter,
            }, this.$attrs);
        },
        enumerable: false,
        configurable: true
    });
    /* mounted */
    BoothCascader.prototype.dateRangeChange = function (val) {
        if (val && val.length) {
            this.init();
        }
    };
    /* method */
    BoothCascader.prototype.init = function () {
        var _this = this;
        var dateRange = this.dateRange;
        if (!dateRange || !dateRange.length)
            return false;
        var params = {
            startAt: dateRange[0],
            endAt: dateRange[1],
            limit: 2000,
        };
        getStopWithBoothClue(params).then(function (result) {
            var hasExtraData = true; // 是否需要额外插入数据
            _this.options = result.records.filter(function (item) { return item.boothList && item.boothList.length; }).map(function (item) {
                return {
                    value: item.shopId,
                    label: item.shopName,
                    children: item.boothList.map(function (iitem) {
                        if (_this.extraParams && item.shopId === _this.extraParams.shopId && iitem.id === _this.extraParams.boothId) {
                            hasExtraData = false;
                        }
                        return {
                            value: iitem.id,
                            label: iitem.name,
                            status: iitem.clueStatus,
                        };
                    }),
                };
            });
            if (_this.extraParams && hasExtraData) {
                var isAssgin_1 = false; // 是否已经赋值
                _this.options.map(function (item) {
                    if (item.value === _this.extraParams.shopId) {
                        isAssgin_1 = true;
                        item.children.push({
                            value: _this.extraParams.boothId,
                            label: _this.extraParams.boothName,
                            status: '',
                        });
                    }
                });
                if (!isAssgin_1) { // 如果是没有赋值情况下
                    _this.options.push({
                        value: _this.extraParams.shopId,
                        label: _this.extraParams.shopName,
                        children: [{
                                value: _this.extraParams.boothId,
                                label: _this.extraParams.boothName,
                                status: '',
                            }],
                    });
                }
            }
        });
    };
    BoothCascader.prototype.changeHandle = function (val) {
        this.checkOptions = val;
    };
    BoothCascader.prototype.inputEnter = function (node, keyword) {
        if (node.text.indexOf(keyword) !== -1) {
            return true;
        }
    };
    __decorate([
        Prop({
            type: Boolean,
            default: true,
        })
    ], BoothCascader.prototype, "multiple", void 0);
    __decorate([
        Prop({
            type: [String, Function],
            default: 'label',
        })
    ], BoothCascader.prototype, "nameStr", void 0);
    __decorate([
        Prop({
            type: String,
            default: 'value',
        })
    ], BoothCascader.prototype, "idStr", void 0);
    __decorate([
        Prop({
            type: Array,
            default: function () {
                return [];
            },
        })
    ], BoothCascader.prototype, "dateRange", void 0);
    __decorate([
        Prop({
            type: Object,
            default: function () { },
        })
    ], BoothCascader.prototype, "extraParams", void 0);
    __decorate([
        Watch('dateRange', {
            immediate: true,
            deep: true,
        })
    ], BoothCascader.prototype, "dateRangeChange", null);
    BoothCascader = __decorate([
        Component({
            components: {
                ScheduleTag: ScheduleTag,
            },
        })
    ], BoothCascader);
    return BoothCascader;
}(Vue));
export default BoothCascader;
